import { render, staticRenderFns } from "./OvenUsersRemove.vue?vue&type=template&id=5e2ed652&"
import script from "./OvenUsersRemove.vue?vue&type=script&lang=js&"
export * from "./OvenUsersRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports